/* eslint react/no-unused-state: 1 */
/* eslint no-undef: 1 */

import 'react-dates/initialize';
import React from 'react';
import { Logger, Auth } from 'aws-amplify';
import Search from './Search';
import './Dashboard.scss';

const logger = new Logger('Dashboard.js');

class Dashboard extends React.Component {
  constructor() {
    super();

    this.state = {};
  }

  componentDidMount = () => {
    Auth.currentAuthenticatedUser().then((user) => {
      logger.info('Logged In User', user.signInUserSession.idToken.payload);
      this.setState({ currentUser: user.signInUserSession.idToken.payload.email });
    })
    .catch((error) => {
      logger.error('User is not authenticated ', error);
      throw error;
    });
  }

  render() {
    const { currentUser } = this.state;

    return (
      currentUser ?
        <div className="App">
          <Search currentUser={currentUser} />
        </div>
      : null
    );
  }
}

export default Dashboard;
